export default __webpack_public_path__ + "cef5aa6c7c15a8080e07424db27813a2.svg";